"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
var initialState = {
  pickup: undefined,
  delivery: undefined
};
exports.initialState = initialState;